import React from "react";

const Privacy = () => {
  const points = [
    {
      point:
        "Identity & Contact Data – name, date of birth, mailing address, email, phone numbers, password",
    },
    {
      point:
        "Health & Pharmacy Data (PHI) – prescriptions, pharmacy preferences, medical information, insurance details, lab results, medical images",
    },
    { point: "Payment Data – credit/debit card numbers, billing address" },
    {
      point:
        "Government & Professional Credentials – driver’s license or government ID, NPI, specialty (for Providers)",
    },
    {
      point:
        "Communications – messages, survey responses, support inquiries If you provide information about someone else, you represent that you have their permission.",
    },
  ];
  const points2 = [
    { point: "Device identifiers, IP address, browser type, OS version" },
    { point: "Approximate geolocation, language settings" },
    {
      point: "Pages viewed, links clicked, session timestamps, referring URLs",
    },
    {
      point: "Mobile device information (e.g., model, OS, unique ID)",
    },
  ];
  const points3 = [
    {
      point:
        "Provide, personalize, and improve the Services and related customer support.",
    },
    {
      point:
        "Facilitate prescription processing, telehealth visits, payments, and discount programs.",
    },
    {
      point: "Conduct research, analytics, and internal business operations.",
    },
    {
      point:
        "Send transactional messages (e.g., appointment reminders, billing notices) and marketing communications (which you may opt out of as described in Section 8).",
    },
    {
      point:
        "Detect, investigate, and prevent fraud, security incidents, and misuse of the Services.",
    },
    {
      point: "Comply with legal, regulatory, and contractual obligations.",
    },
  ];
  const points4 = [
    {
      point:
        "With Service Providers & Business Associates who perform services for us under written agreements that require them to protect your information (e.g., cloud hosting, payment processing, analytics, marketing, identity verification).",
    },
    {
      point:
        "With Healthcare Providers & PBMs to facilitate your care, validate prescriptions, or operate discount programs.",
    },
    {
      point:
        "With Marketing Partners to deliver tailored ads or manufacturer copay offers (no PHI is shared for third-party marketing without your written authorization).",
    },
    {
      point:
        "For Legal Reasons – to comply with law, respond to legal process or public health reporting, emergencies, or protect the rights, property, or safety of UTIRX.com, our users, or others.",
    },
    {
      point:
        "In Corporate Transactions – if we are involved in a merger, acquisition, financing, or sale of assets, your information may be transferred as part of that transaction.",
    },
  ];
  const points5 = [
    {
      point:
        "Access – Request an electronic or paper copy of your medical record and other health information.",
    },
    {
      point:
        "Amend – Ask us to correct PHI you believe is inaccurate or incomplete.",
    },
    {
      point:
        "Accounting of Disclosures – Receive a list of certain disclosures we have made of your PHI.",
    },
    {
      point:
        "Request Restrictions – Ask us to limit the PHI we use or disclose for treatment, payment, or healthcare operations.",
    },
    {
      point:
        "Confidential Communications – Request that we contact you in a specific way (e.g., at a different mailing address).",
    },
    {
      point:
        "File a Complaint – Complain if you believe your privacy rights have been violated (see Section 6 for how).",
    },
  ];
  const points6 = [
    {
      point:
        "Required by law to maintain the privacy and security of your PHI.",
    },
    {
      point:
        "Required to provide you with this notice of Privacy Practices that describes our legal duties and privacy practices.",
    },
    {
      point:
        "Required to follow the duties and privacy practices described in this Privacy Policy.",
    },
    {
      point:
        "Required to notify you following a breach of unsecured PHI as defined by HIPAA.",
    },
    {
      point:
        "Confidential Communications – Request that we contact you in a specific way (e.g., at a different mailing address).",
    },
    {
      point:
        "File a Complaint – Complain if you believe your privacy rights have been violated (see Section 6 for how).",
    },
  ];
  const points7 = [
    {
      point:
        "Marketing Opt-Outs – Follow the instructions in promotional emails or reply STOP to marketing texts.",
    },
    {
      point:
        "Cookie Controls – Adjust your browser or device settings to refuse cookies; some features may not function properly.",
    },
    {
      point:
        "Deletion & Access Requests (CCPA/State Laws) – U.S. residents may submit requests at https://www.UTIRX.com/requestdeletion. We will verify your identity before fulfilling certain requests.",
    },
  ];

  return (
    <div className="legal-page">
      <div className="content-container">
        <h2>Privacy Policy/HIPAA Notice for UTIRX.com</h2>
      <p>
        This Privacy Policy describes how UTIRX.com, LLC ("UTIRX.com," "we,"
        "our," or "us") collects, uses, discloses, and safeguards information
        when you visit UTIRX.com or otherwise access our websites, mobile
        applications, and related content, products, and services (collectively,
        the "Services"). Your use of the Services is also governed by our Terms
        of Use, Privacy Policy, and HIPAA forms.
      </p>
      <p>
        The forms explain, in detail, how we use and disclose your Protected
        Health Information ("PHI") and the rights you have under the Health
        Insurance Portability and Accountability Act of 1996 ("HIPAA"). By
        accessing or using the Services, you acknowledge that you have read and
        understand all the forms and terms and you consent to the practices
        described herein. If you do not agree, please do not access or use the
        Services.
      </p>

      <p>
        <b>1. Information We Collect</b>
      </p>
      <p>1.1 Information You Provide</p>
      <p>Depending on which Services you use, you may provide us with: </p>
      <ul>
        {points.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ul>
      <p>1.2 Information We Collect Automatically</p>
      <p>
        We and our service providers automatically collect certain information
        via cookies, pixels, SDKs, and similar technologies, including:
      </p>
      <ul>
        {points2.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ul>
      <p>1.3 Information from Third Parties</p>
      <p>We may receive information about you from:</p>
      <ul>
        <li>
          Healthcare partners & Providers – prescriptions, visit summaries,
          contact data
        </li>
        <li>
          Data & Marketing partners – demographic segments, online activity,
          lead lists
        </li>
        <li>
          Pharmacy Benefit Managers (PBMs) – de-identified dispensing data
        </li>
      </ul>
      <p>
        <b>2. How We Use Your Information</b>
      </p>
      <p>We use the information we collect to</p>
      <ol>
        {points3.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ol>
      <p>
        When we use or disclose PHI, we do so in accordance with HIPAA and our
        Privacy Policy—for example, to provide treatment, obtain payment, or
        conduct healthcare operations.
      </p>

      <p>
        <b>3. How We Share Information</b>
      </p>
      <ul>
        {points4.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ul>
      <p>
        We may disclose de-identified or aggregated data that cannot reasonably
        identify you for research or analytics.
      </p>
      <p>
        <b>4. Your HIPAA Rights Regarding PHI</b>
      </p>
      <p>Under HIPAA, you have the right to:</p>

      <ul>
        {points5.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ul>
      <p>
        We will not retaliate against you for exercising any of these rights. To
        exercise your HIPAA rights, please follow the instructions in our NPP or
        contact our Privacy Officer (Section 6).
      </p>

      <p>
        <b>5. Our Legal Duties Concerning PHI</b>
      </p>
      <p>We are a "covered entity" under HIPAA and therefore:</p>
      <ul>
        {points6.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ul>
      <p>
        We will not use or disclose your PHI for purposes not described in our
        term without your written authorization. If you provide an
        authorization, you may revoke it at any time in writing.
      </p>
      <p>
        <b>6. Privacy Official & Contact Information</b>
      </p>
      <p>
        If you have questions about this Privacy Policy, our HIPAA practices, or
        wish to exercise your rights, contact:
      </p>
      <p>Privacy Officer</p>
      <p>UTIRX.com, LLC</p>
      <p>Dr. Arash Rafiei</p>
      <p>Email: Onlineutimeds@gmail.com</p>

      <p>
        <b>7. Children’s Privacy</b>
      </p>
      <p>
        The Services are intended only for users 18 years of age or older. We do
        not knowingly collect personal information from children under 13. If we
        learn that we have inadvertently collected such information, we will
        delete it.
      </p>
      <p>
        <b>8. Your Other Choices & State Privacy Rights</b>
      </p>
      <ul>
        {points7.map((i) => {
          return <li>{i.point}</li>;
        })}
      </ul>
      <p>
        <b>9. Data Security</b>
      </p>
      <p>
        We maintain reasonable administrative, technical, and physical
        safeguards to protect information in our custody and control. No method
        of transmission over the Internet or storage system is 100 % secure; we
        cannot guarantee absolute security.
      </p>
      <p>
        <b>10. International Users</b>
      </p>
      <p>
        The Services are intended for U.S. residents only. If you are located
        outside the United States, please do not use the Services.
      </p>
      <p>
        <b>11. Changes to This Privacy Policy</b>
      </p>
      <p>
        We may update this Privacy Policy periodically. Your continued use of
        the Services after an update constitutes acceptance of the revised
        policy.
      </p>
      <p>
        By continuing to use the Services, you acknowledge that you have read,
        understood, and agree to be bound by this Privacy Policy and terms.
      </p>
      </div>
    </div>
  );
};

export default Privacy;
